package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.Serializable

@Serializable
data class CommentDto(
    val id: Int,
    val postId: Int,
    val authorName: String,
    val content: String,
    val createdAt: String,
)

@Serializable
data class CreateCommentRequestDto(
    val authorName: String?,
    val content: String,
)
